/**
 *
 * InternationalCalls
 *
 */
import React, { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FreeInternationalCallsHero } from "./components/free-international-calls-hero";
import { InternationalCallingPlan } from "./components/international-calling-plan";
import { Travelling } from "./components/travelling";
import { Faq } from "./components/faq";
import { Footer } from "app/components/AdminLayout/Footer";

interface Props {}

export const InternationalCalls = memo((props: Props) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#international-roaming") {
      const element = document.getElementById("international-roaming");
      if (element) {
        const offsetPosition =
          element.getBoundingClientRect().top + window.scrollY - 145;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  }, [hash]);

  return (
    <React.Fragment>
      <main className="overflow-hidden">
        {/* Free International Calling Hero to 170+ countries Section */}
        <FreeInternationalCallsHero />
        {/* International Calling Plan Section */}
        <InternationalCallingPlan />
        {/* Travelling Section */}
        <Travelling />
        {/* Faq Section */}
        <Faq />
      </main>
      <Footer />
    </React.Fragment>
  );
});
